<template>
    <q-page padding>
        <div class="q-display-1 q-mb-md text-secondary">
            <q-icon name="far fa-ticket-alt" class="q-mb-sm" /> {{ $t('rewards') }}
        </div>

        <q-tabs v-model="tab">
            <q-tab slot="title" name="basic-data" :label="$t('basic_data')" />
            <q-tab slot="title" name="vouchers" :label="$t('vouchers')" v-if="showVouchers" />

            <q-tab-pane name="basic-data">
                <div class="row gutter-sm">
                    <div class="col-xs-12 col-sm-12">
                        <q-input v-model="title" :float-label="$t('title')" :error="$v.title.$error" @input="$v.title.$touch" />
                    </div>

                    <div class="col-xs-12 col-sm-12">
                        <q-select v-model="reward_categorie" :options="reward_categories" :float-label="$t('reward_categories')" :error="$v.reward_categories.$error" chips filter autofocus-filter />
                    </div>

                    <div class="col-xs-12 col-sm-12">
                        <q-input type="number" v-model="price" :float-label="$t('price')" :error="$v.price.$error" @input="$v.price.$touch" />
                    </div>

                    <div class="col-xs-12 col-sm-12">
                        <q-input v-model="suplyer_name" :float-label="$t('suplyer_name')" :error="$v.suplyer_name.$error" @input="$v.suplyer_name.$touch" />
                    </div>

                    <div class="col-xs-12 col-sm-12">
                        <p class="caption">{{ $t('description') }}</p>

                        <q-editor
                            v-model="description"
                            :error="$v.description.$error" @input="$v.description.$touch"
                            :toolbar="[
                                ['bold', 'italic', 'strike', 'underline'],
                                ['left', 'center', 'right', 'justify'],
                                ['link', 'upload'],
                                [
                                    {
                                        label: null,
                                        icon: 'fas fa-font',
                                        fixedLabel: true,
                                        fixedIcon: true,
                                        list: 'no-icons',
                                        options: ['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'code']
                                    },
                                    {
                                        label: null,
                                        icon: 'fas fa-text-height',
                                        fixedLabel: true,
                                        fixedIcon: true,
                                        list: 'no-icons',
                                        options: ['size-1', 'size-2', 'size-3', 'size-4', 'size-5', 'size-6', 'size-7']
                                    },
                                    'removeFormat'
                                ],
                                ['quote', 'unordered', 'ordered'],
                                ['custom_btn']
                            ]"
                            :definitions="{
                                bold: {label: null, icon: 'fas fa-bold'},
                                italic: {label: null, icon: 'fas fa-italic'},
                                strike: {label: null, icon: 'fas fa-strikethrough'},
                                underline: {label: null, icon: 'fas fa-underline'},
                                left: {label: null, icon: 'fas fa-align-left'},
                                center: {label: null, icon: 'fas fa-align-center'},
                                right: {label: null, icon: 'fas fa-align-right'},
                                justify: {label: null, icon: 'fas fa-align-justify'},
                                link: {label: null, icon: 'fas fa-link'},
                                upload: { tip: null, icon: 'fas fa-file-image', handler: insertImg },
                                removeFormat: {label: null, icon: 'fas fa-eraser'},
                                quote: {label: null, icon: 'fas fa-quote-right'},
                                unordered: {label: null, icon: 'fas fa-list-ul'},
                                ordered: {label: null, icon: 'fas fa-list-ol'}
                            }"
                            >
                            <q-btn
                                slot="custom_btn"
                                dense
                                flat
                                color="black"
                                icon="fal fa-code"
                                label="HTML"
                                @click="show_html = true"
                            />
                        </q-editor>
                    </div>

                    <div class="col-xs-12 col-sm-12">
                        <q-select v-model="reward_type" :options="getRewardTypeTranslation" :disable="disableFieldType" :float-label="$t('reward_type')" :error="$v.reward_type.$error" chips filter autofocus-filter />
                    </div>

                    <div class="col-xs-12 col-sm-12" v-if="reward_type == 2">
                        <p class="caption">{{ $t('redeen_instructions') }}</p>

                        <q-editor
                            v-model="redeen_instructions"
                            :error="$v.redeen_instructions.$error" @input="$v.redeen_instructions.$touch"
                            :toolbar="[
                                ['bold', 'italic', 'strike', 'underline'],
                                ['left', 'center', 'right', 'justify'],
                                ['link', 'upload'],
                                [
                                    {
                                        label: null,
                                        icon: 'fas fa-font',
                                        fixedLabel: true,
                                        fixedIcon: true,
                                        list: 'no-icons',
                                        options: ['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'code']
                                    },
                                    {
                                        label: null,
                                        icon: 'fas fa-text-height',
                                        fixedLabel: true,
                                        fixedIcon: true,
                                        list: 'no-icons',
                                        options: ['size-1', 'size-2', 'size-3', 'size-4', 'size-5', 'size-6', 'size-7']
                                    },
                                    'removeFormat'
                                ],
                                ['quote', 'unordered', 'ordered'],
                                ['custom_btn']
                            ]"
                            :definitions="{
                                bold: {label: null, icon: 'fas fa-bold'},
                                italic: {label: null, icon: 'fas fa-italic'},
                                strike: {label: null, icon: 'fas fa-strikethrough'},
                                underline: {label: null, icon: 'fas fa-underline'},
                                left: {label: null, icon: 'fas fa-align-left'},
                                center: {label: null, icon: 'fas fa-align-center'},
                                right: {label: null, icon: 'fas fa-align-right'},
                                justify: {label: null, icon: 'fas fa-align-justify'},
                                link: {label: null, icon: 'fas fa-link'},
                                upload: { tip: null, icon: 'fas fa-file-image', handler: insertImg },
                                removeFormat: {label: null, icon: 'fas fa-eraser'},
                                quote: {label: null, icon: 'fas fa-quote-right'},
                                unordered: {label: null, icon: 'fas fa-list-ul'},
                                ordered: {label: null, icon: 'fas fa-list-ol'}
                            }"
                            >
                            <q-btn
                                slot="custom_btn"
                                dense
                                flat
                                color="black"
                                icon="fal fa-code"
                                label="HTML"
                                @click="show_html_redeen_instructions = true"
                            />
                        </q-editor>
                    </div>

                    <div class="col-xs-12 col-sm-12" v-if="reward_type == 1">
                        <q-input type="number" v-model="qty_in_stock" :float-label="$t('in_stock')" />
                    </div>

                    <div class="col-xs-12 col-sm-12">
                        <p class="caption">{{ $t('reward_images') }}</p>

                        <uploader content_type="images" @fileUploaded="imageDesktopUploaded" :multiple="false" :cropper="true" :error="$v.reward_images.$error" @input="$v.reward_images.$touch" />

                        <p v-if="reward_images" class="q-mt-md file-url">
                            <span v-for="(item, index) in reward_images" :key="index">
                                <q-btn dense round flat icon="fal fa-trash-alt" color="negative" class="q-ml-sm" @click="removeImage(index)" />
                                <a :href="item" target="_blank"> {{ $truncateLink(item) }}</a>
                                <br>
                            </span>
                        </p>
                    </div>

                    <div class="col-xs-12 col-sm-12">
                        <q-tabs v-model="tab_permission" color="secondary" class="shadow-1">
                            <q-tab slot="title" name="permissions" icon="fal fa-clipboard-list-check" :label="$t('permissions')" />

                            <q-tab-pane name="permissions" class="q-px-lg q-pb-xl">
                                <div class="row gutter-sm">
                                    <div class="col-xs-12 col-sm-12">
                                        <q-select v-model="area" :options="areas" :float-label="$t('areas')" :error="$v.area.$error" @input="$v.area.$touch" multiple chips />
                                    </div>

                                    <div class="col-xs-12 col-sm-12">
                                        <p class="caption">{{ $t('profiles') }}</p>

                                        <div class="row gutter-sm">
                                            <div class="col-xs-12 col-sm-12">
                                                <q-checkbox v-model="all_profiles" :val="true" :label="$t('all')" @input="checkAll()" />
                                            </div>

                                            <div class="col-xs-12 col-sm-4" v-for="(item, index) in profiles" :key="index" :class="getErrorClass($v.profile.$error)">
                                                <q-checkbox keep-color v-model="profile" :val="item.value" :label="item.label" @input="$v.profile.$touch" :color="getErrorColor($v.profile.$error)" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </q-tab-pane>
                        </q-tabs>
                    </div>

                    <div class="col-xs-12 col-sm-6">
                        <p class="caption">{{ $t('status') }}</p>
                        <q-btn-toggle v-model="status" :toggle-color="getColorStatus" :options="statuses" />
                    </div>

                    <div class="col-xs-12 col-sm-6">
                        <p class="caption">{{ $t('is_featured') }}</p>
                        <q-btn-toggle v-model="is_featured" :toggle-color="getColorFeatured" :options="featured" />
                    </div>
                </div>

                <div class="row gutter-sm justify-end q-mt-lg">
                    <div class="col-xs-12 col-sm-3" :class="getOrder('cancel')">
                        <q-btn color="tertiary" class="full-width" :label="$t('back')" icon="far fa-chevron-left" @click="$router.push({ name: 'rewards' })" />
                    </div>

                    <div class="col-xs-12 col-sm-3" :class="getOrder('save')">
                        <q-btn color="secondary" class="full-width" :label="$t('save')" icon="far fa-save" @click="saveData()" />
                    </div>
                </div>
            </q-tab-pane>

            <q-tab-pane name="vouchers">
                <vouchers :id_reward="id_reward" />
            </q-tab-pane>
        </q-tabs>

        <q-modal v-model="show_html" :content-css="{minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh'}" no-backdrop-dismiss no-esc-dismiss>
            <q-modal-layout>
                <q-toolbar slot="header">
                    <q-btn flat round dense @click="show_html = false" icon="fas fa-times" />
                    <q-toolbar-title>
                        HTML
                    </q-toolbar-title>
                </q-toolbar>

                <div class="layout-padding">
                    <div class="row">
                        <div class="col-12">
                            <q-input type="textarea" rows="10" float-label="HTML" v-model="description" />
                        </div>
                    </div>

                    <div class="row gutter-sm justify-end q-mt-lg">
                        <div class="col-xs-12 col-sm-3">
                            <q-btn color="tertiary" class="full-width" :label="$t('close')" icon="far fa-ban" @click="show_html = false" />
                        </div>
                    </div>
                </div>
            </q-modal-layout>
        </q-modal>

        <q-modal v-model="show_html_redeen_instructions" :content-css="{minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh'}" no-backdrop-dismiss no-esc-dismiss>
            <q-modal-layout>
                <q-toolbar slot="header">
                    <q-btn flat round dense @click="show_html_redeen_instructions = false" icon="fas fa-times" />
                    <q-toolbar-title>
                        HTML
                    </q-toolbar-title>
                </q-toolbar>

                <div class="layout-padding">
                    <div class="row">
                        <div class="col-12">
                            <q-input type="textarea" rows="10" float-label="HTML" v-model="redeen_instructions" />
                        </div>
                    </div>

                    <div class="row gutter-sm justify-end q-mt-lg">
                        <div class="col-xs-12 col-sm-3">
                            <q-btn color="tertiary" class="full-width" :label="$t('close')" icon="far fa-ban" @click="show_html_redeen_instructions = false" />
                        </div>
                    </div>
                </div>
            </q-modal-layout>
        </q-modal>
    </q-page>
</template>

<script>
import { mapGetters } from 'vuex'
import { required, requiredIf } from 'vuelidate/lib/validators'
import Uploader from 'components/Uploader'
import Vouchers from 'components/admin/rewards/Vouchers'
import * as moment from 'moment'
import * as tz from 'moment-timezone'
import { BlobServiceClient } from '@azure/storage-blob'

export default {
    i18nOptions: { namespaces: [ "custom", "common", "training", "admin", "rewards" ] },

    components: {
        'uploader': Uploader,
        'vouchers': Vouchers
    },

    data() {
        return {
            action_id: '',
            all_profiles: false,
            area: [],
            description: '',
            featured: [{
                label: this.$t('yes'),
                value: true
            }, {
                label: this.$t('no'),
                value: false
            }],
            id_code: '',
            id_reward: '',
            is_featured: false,
            loading: false,
            price: '',
            profile: [],
            qty_in_stock: '',
            reward_categorie: '',
            reward_categorie_multiple: '',
            reward_images: [],
            reward_type: '',
            show_html: false,
            status: 1,
            statuses: [{
                label: this.$t('active_f'),
                value: 1
            }, {
                label: this.$t('inactive_f'),
                value: 2
            }],
            suplyer_name: '',
            tab: 'basic-data',
            tab_permission: 'permissions',
            title: '',
            redeen_instructions: '',
            show_html_redeen_instructions: false,
            cancel_token: '',
            source: '',
            fileUrl: ''
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            areas: 'registration_lists/country_areas',
            reward_types: 'registration_lists/reward_types',
            profiles: 'registration_lists/profiles',
            reward_categories: 'registration_lists/reward_categories',
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        showVouchers() {
            if (this.id_reward !== 0 && this.reward_type !== 1) return true
            else return false
        },

        disableFieldType(){
            if (this.status === 2 || this.status === 3 || this.id_reward != 0) return true
            else return false
        },

        disableFields() {
            if (this.status === 2 || this.status === 3 ) return true
            else return false
        },

        getColorFeatured() {
            if (this.is_featured == true) return 'positive'
            else return 'negative'
        },

        getColorStatus() {
            if (this.status == 1) return 'positive'
            else return 'warning'
        },

        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '100vw'
            else return '80vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '90vw'
        },

        getRewardTypeTranslation() {
            return this.reward_types.map(reward => {
                return {
                    ...reward,
                    "label": this.$t(reward.label)
                }
            })
        }
    },

    methods: {
        fetchData() {
            this.$q.loading.show()

            this.$axios.get('/admin_rewards/rewards/' + this.id_reward + '/', this.getHeader)
            .then(response => {
                this.title = response.data.title
                this.description = response.data.description
                this.status = response.data.status
                response.data.profiles.forEach(profile => {
                    this.profile.push(profile)
                })
                response.data.areas.forEach(area => {
                    this.area.push(area)
                })
                this.redeen_instructions = response.data.redeen_instructions
                this.reward_categorie = response.data.categories[0]
                this.reward_type = response.data.reward_type
                this.price = parseInt(response.data.price)
                this.qty_in_stock = response.data.qty_in_stock
                this.suplyer_name = response.data.suplyer_name
                this.is_featured =  response.data.is_featured
                response.data.reward_images.forEach((image, index) => {
                    this.reward_images.push(image.image)
                })
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.$q.loading.hide()
            })
        },

        fetchLists() {
            this.$axios.get('/accounts/get_registration_lists/', this.getHeader)
            .then(response => {
                this.$store.dispatch('registration_lists/SET_LISTS', [response.data])
            })
            .catch(e => {
                console.log(e)
            })
        },

        saveData(type) {
            this.$v.$touch()

            if (!this.$v.$error) {
                this.$q.loading.show()

                let reward_images = this.reward_images.map(e => {
                    return {
                        "image": e
                    }
                })

                let data = {
                    title: this.title,
                    description: this.description,
                    reward_type: this.reward_type,
                    areas: this.area,
                    categories: this.reward_categorie ? [this.reward_categorie] : this.reward_categorie_multiple,
                    profiles: this.profile,
                    price: parseFloat(this.price),
                    suplyer_name: this.suplyer_name,
                    is_featured: this.is_featured,
                    reward_images: reward_images,
                    status: this.status,
                }

                if (this.reward_type === 1) data.qty_in_stock = this.qty_in_stock
                else data.redeen_instructions = this.redeen_instructions

                if (this.id_reward != 0) {
                    this.$axios.put('/admin_rewards/rewards/' + this.id_reward + '/', data, this.getHeader)
                    .then(response => {
                        this.$q.loading.hide()
                        if (type == 'show_redeen_code') {
                            this.show_redeen_code = true
                        }
                        else {
                            this.$q.notify({
                                message: this.$t('reward_edit_success'),
                                type: 'positive',
                                icon: 'fal fa-save'
                            })

                            this.$router.push({ name: 'rewards' })
                        }
                    })
                    .catch(e => {
                        this.$q.loading.hide()
                        console.log(e)
                    })
                }
                else {
                    this.$axios.post('/admin_rewards/rewards/', data, this.getHeader)
                    .then(response => {
                        this.$q.loading.hide()
                        if (type == 'show_redeen_code') {
                            this.id_reward = response.data.id
                            this.$router.push({ name: 'reward', params: { id: response.data.id } })
                            this.show_redeen_code = true
                        }
                        else {
                            this.$router.push({ name: 'rewards' })
                        }

                    })
                    .catch(e => {
                        this.$q.loading.hide()
                        console.log(e)
                    })
                }
            }
            else {
                this.$q.notify({
                    message: this.$t('make_sure_that_all_fields_are_filled_in'),
                    type: 'negative',
                    icon: 'fal fa-exclamation-triangle',
                    position: 'top'
                })
            }
        },

        insertImg() {
            const input = document.createElement('input')
            input.type = 'file'
            input.accept = '.png, .jpg, .gif'
            let file

            input.onchange = _ => {
                const files = Array.from(input.files)
                file = files[0]

                this.uploadFile(file)

            }
            input.click()
        },

        uploadFile (file) {
            let date = moment()

            let fd = new FormData()
            fd.append('filename', file.name)
            fd.append('file_directory', `media/html_images/reward/${date.year()}/${date.month() + 1}/`)

            this.$axios.post('/api/files/policy/', fd, this.getHeader, { cancelToken: this.source.token })
            .then(response => {
                return new Promise((resolve) => {
                    this.$q.loading.show()

                    if (response.data.origin === 'azure') {
                        const blobServiceClient = new BlobServiceClient(
                            `${response.data.base_url}?${response.data.sas_token}`
                        )

                        const main = async () => {
                            const container_client = blobServiceClient.getContainerClient('')

                            const block_blob_client = container_client.getBlockBlobClient(response.data.filename)
                            const upload_blob_response = await block_blob_client.uploadBrowserData(file)

                            let fd_complete = new FormData()
                            fd_complete.append('uploaded', true)
                            fd_complete.append('fileSize', file.size)
                            fd_complete.append('file', response.data.file_id)

                            if (this.custom_directory) {
                                fd_complete.append('not_signed', true)
                                fd_complete.append('bucket_name', 'static')
                            }

                            this.$axios.post('/api/files/complete/', fd_complete, this.getHeader)
                            .then(response => {
                                this.fileUrl = response.data.fileUrl
                                document.execCommand('insertHTML', true, '<div><img class="uploadBase" src="' + this.fileUrl + '" style="max-width: 100%" /></div>')
                            })
                            .finally(() => {
                                resolve()
                                this.$q.loading.hide()
                            })
                        }

                        main()
                    }
                    else {
                        let content_type = file.type != '' ? file.type : 'application/octet-stream'
                        let policy = response.data
                        let file_name = policy.filename
                        let key_path = policy.file_bucket_path

                        let fd_s3 = new FormData()
                        fd_s3.append('key', key_path + file_name)
                        fd_s3.append('acl','private')
                        fd_s3.append('Content-Type', content_type)
                        fd_s3.append("AWSAccessKeyId", policy.key)
                        fd_s3.append('Policy', policy.policy)
                        fd_s3.append('filename', file_name)
                        fd_s3.append('Signature', policy.signature)
                        fd_s3.append('file', file)

                        this.cancel_token = this.$axios.CancelToken
                        this.source = this.cancel_token.source()

                        this.$axios.post(process.env.BUCKET_URL, fd_s3,
                        {
                            // onUploadProgress: function( event ) {
                            //     updateProgress(event.loaded / event.total)
                            // },
                            // cancelToken: this.source.token

                        })
                        .then(response => {
                            let fd_complete = new FormData()
                            fd_complete.append('uploaded', true)
                            fd_complete.append('fileSize', file.size)
                            fd_complete.append('file', policy.file_id)

                            this.$axios.post('/api/files/complete/', fd_complete, this.getHeader)
                            .then(response => {
                                let data = {
                                    file_url: response.data.fileUrl
                                }

                                this.$axios.post('/utils/presigned_url/', data, this.getHeader)
                                .then(response => {
                                    document.execCommand('insertHTML', true, `<div><img class="uploadBase" src="${response.data.file_url}" style="max-width: 100%" /></div>`)
                                })
                                .catch(e => {
                                    console.log(e)
                                })
                                .finally(() => {
                                    this.$q.loading.hide()
                                })
                            })
                            .finally(() => {
                                this.$q.loading.hide()
                            })
                        })
                        .finally(() => {
                            resolve()
                        })
                    }
                })
            })
            .catch(e => {
                console.log(e)
                this.$q.loading.hide()
            })
        },

        checkAll() {
            if (this.all_profiles) {
                this.profiles.forEach(element => {
                    this.profile.push(element.value)
                })
            }
            else {
                this.profile = []
            }
        },

        getErrorClass(state) {
            if (state) return 'checkbox-error'
            else return ''
        },

        getErrorColor(state) {
            if (state) return 'negative'
            else return ''
        },

        getErrorClass(state) {
            if (state) return 'checkbox-error'
            else return ''
        },

        getOrder(name) {
            if (name == 'cancel') {
                if (this.$q.platform.is.mobile) return 'order-last'
                else return 'order-first'
            }
            else if (name == 'save') {
                if (this.$q.platform.is.mobile) return 'order-first'
                else return 'order-last'
            }
        },

        imageDesktopUploaded(url) {
            this.reward_images.push(url)
        },

        returnToReward() {
            this.request({
                pagination: this.server_pagination
            })

            this.show_redeen_code = false
        },

        removeImage(index) {
            this.reward_images.splice(index, 1)
        }
    },

    created() {
        this.id_reward = this.$route.params.id
        if (this.id_reward != 0) this.fetchData()

        this.fetchLists()
    },

    validations() {
        return {
            title: { required },
            reward_type: {required},
            reward_categories: {required},
            areas: { required },
            description: { required },
            price: {required},
            reward_images:{required},
            suplyer_name: {required},
            area: {
                requiredIf: requiredIf(() => {
                    return this.tab == 'permissions' ? true : false
                })
            },
            profile: {
                requiredIf: requiredIf(() => {
                    return this.tab == 'permissions' ? true : false
                })
            },
            redeen_instructions: {
                requiredIf: requiredIf(() => {
                    return this.reward_type == 2 ? true : false
                })
            }
        }
    },
}
</script>

<style>

</style>
